module.exports = __webpack_public_path__ + "img/16.71d4f35f.jpg";